import { useEffect, useState } from "react";
import { UserInfo } from "@/interfaces/user-interface";
import { readItems, readMe } from "@directus/sdk";
import directus from "@/lib/directus";


export default function useFindUser() {
    const [user, setUser] = useState<UserInfo | undefined>(undefined);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCurrentUser = async () => {
      try {
        let accessToken: string | undefined;
        try {
          accessToken = (JSON.parse(localStorage.getItem('directus_auth') || '{}') || {}).access_token;
        } catch {
          accessToken = undefined;
        }

        if (!accessToken) {
          setUser(undefined);
          return;
        }

        const currentUser = await directus.request(readMe());
        if (!currentUser) {
          setUser(undefined);
          return;
        }

        const commercialRelations = await directus.request(readItems("commercial_relations", {
          filter: {
            user_id: { _eq: currentUser.id },
          },
          limit: 1,
        }));

        // The commercial code comes only from commercial_relations, never
        // from directus_users.phone_number.
        const relation = commercialRelations?.[0];
        currentUser.phone_number = relation?.commercial_phoneNumber || undefined;
        currentUser.balance = relation?.balance;

        setUser(currentUser as UserInfo);
      } catch (error) {
        console.error("Erreur lors de la récupération de l'utilisateur:", error);
        setUser(undefined);
      } finally {
        setLoading(false);
      }
    };

        fetchCurrentUser();
    }, []);

    return {
        user,
        setUser,
        isLoading,
    };
}
